/**
 * @license
 * @copyright Copyright Motili Inc., 2024 All Rights Reserved
 */
import { post, get, del } from 'common/services/ApiService';
import Config from 'Config';

export function getMotiliCalendarAvailability() {
    return getScheduler(true, 'contractor/availability');
}

export function getCronofyCalendarAvailability() {
    return getScheduler(true, 'contractor/availabilityList');
}

export function postCalendarPrefs(data) {
    return postScheduler(true, 'contractor/availability', data);
}

export function revokeAuthorization() {
    return getScheduler(true, 'contractor/revoke_calendar_authorization');
}

export function authorizeCalendar() {
    return getScheduler(true, 'contractor/start_calendar_authorization');
}

export function removeCalendarEvent(eventId) {
    return deleteScheduler(`event/${eventId}`);
}

export function getTeamMembers(workOrderId) {
    return getScheduler(true, 'team_member/get_dispatchable', {
        workorderId: workOrderId,
    });
}

export function getCronofyAccount() {
    return getScheduler(true, 'contractor/account');
}

export function getContractorMemberAccount(accountId) {
    return getScheduler(true, `account/${accountId}`);
}

function getScheduler(
    authenticated,
    endpoint,
    query = {},
    logoutOn401 = true,
    token = undefined
) {
    return get(
        authenticated,
        endpoint,
        query,
        logoutOn401,
        token,
        Config.schedulerApiBaseUrl
    );
}

function postScheduler(
    authenticated,
    endpoint,
    requestBody,
    query = {},
    logoutOn401 = true,
    token = undefined
) {
    return post(
        authenticated,
        endpoint,
        requestBody,
        query,
        logoutOn401,
        token,
        Config.schedulerApiBaseUrl
    );
}

function deleteScheduler(endpoint, query = {}, logoutOn401 = true) {
    return del(endpoint, query, logoutOn401, Config.schedulerApiBaseUrl);
}
